// extracted by mini-css-extract-plugin
module.exports = {"MachinesLevel":"MachinesLevel_MachinesLevel__qcp6L","header":"MachinesLevel_header__19s6-","Machine":"MachinesLevel_Machine__12Icc"};